<template>
    <FilterPage
        title="Champs artistiques"
        subtitle="Équipes artistiques"
        v-on="$listeners"
        @reset="handleReset"
    >
        <CheckboxesCriteria
            v-model="value.companies.artisticFields"
            :options="checkboxesOptions"
            @change="handleChanged"
            ref="checkboxes"
        />
    </FilterPage>
</template>

<script>
    import FilterPage from '../../../FilterPage.vue';
    import CheckboxesCriteria from "../../criterias/Checkboxes.vue";

    export default {
        components: {
            FilterPage,
            CheckboxesCriteria,
        },
        props: {
            value: Object,
            criterias: Object,
        },
        computed: {
            checkboxesOptions() {
                return this.criterias.companies.artisticFields;
            },
        },
        methods: {
            handleChanged() {
                this.$emit('input', { ...this.value });
            },
            handleReset() {
                this.$refs.checkboxes.reset();
            },
        },
    }
</script>
